export default __webpack_public_path__ + "3d4d6cb327a68df54de0b29c92cff5f7.png";